import { createRoute, redirect } from "@tanstack/react-router"

import MainAppRoute from "@/rootRoutes/MainApp"

/**
 * The job analytics screen drew the same hard-coded funnel and days-in-stage
 * charts for every job — sample figures presented as this job's records. The
 * job has four tabs now (Today · Pipeline · Files · Notes), so an old link or
 * bookmark here lands on Today instead.
 */
const DashboardAnalyticsPage = createRoute({
  getParentRoute: () => MainAppRoute,
  path: "/jobs/$jobId/analytics",
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/jobs/$jobId/$view", params: { jobId: params.jobId, view: "overview" }, replace: true })
  },
})
export default DashboardAnalyticsPage
